import {CenterHero, TicketHero} from "../../blocks/hero/Hero";
import {Footer} from "../../blocks/footer/Footer";
import {useEffect} from "react";
import {Press} from "../../blocks/press/Press";
import {PrimaryButton} from "../../components/button/Button";
import {API, Entities} from "../../utils/Api";
import {useLoaderData} from "react-router-dom";

export default function PressPage(){
    const data = useLoaderData();
    var presses = data.presses;

    return (
        <>
            <CenterHero
                url={'/benefitshare/img/headerbg3.jpg'}
                megaphone={'Shaping success, sharing great ideas'}
                titles={['Sajtó']}
            ></CenterHero>
            <Press presses={presses}></Press>
            <TicketHero titles={["Sharing ideas, shaping success.Big ideas for happy employees."]} megaphone={"Let's make something great work together."}>
                <PrimaryButton href={'/jegyek'} primaryText={'Jegy vásárlása'} secondaryText={"Biztosítsd a helyedet"}></PrimaryButton>
            </TicketHero>
            <Footer></Footer>
        </>
    )
}


export async function PressLoader(){
    try {
        const response = await API.rest(Entities.press, "GET"); // Várjuk meg az API választ
        return {
            presses: (response!=''?response:[]),
        };
    } catch (error) {
        console.error("Hiba történt az API hívás során:", error);
        return { presses: []}; // Hiba esetén üres tömböt adunk vissza
    }
}